import { z } from "zod"

export const DestinatarioSchema = z.object({ email_masked: z.string() })

export const MOTIVOS = [
    { valor: "NOT_HR", rotulo: "Não sou do RH/folha desta empresa" },
    { valor: "EMAIL_UNUSED", rotulo: "Este e-mail não é mais usado" },
    { valor: "DONT_WANT", rotulo: "Não quero receber" },
    { valor: "OTHER", rotulo: "Outro" },
] as const

export const LIMITE_DO_TEXTO = 500

export const DescadastroSchema = z.object({
    reason: z.enum(["NOT_HR", "EMAIL_UNUSED", "DONT_WANT", "OTHER"], {
        errorMap: () => ({ message: "Escolha o motivo." }),
    }),
    text: z
        .string()
        .trim()
        .max(LIMITE_DO_TEXTO, `Use até ${LIMITE_DO_TEXTO} caracteres.`)
        .optional(),
    hr_email: z
        .string()
        .trim()
        .email("Confira o e-mail do RH: ele não parece um endereço válido.")
        .or(z.literal(""))
        .optional(),
})
export type Descadastro = z.infer<typeof DescadastroSchema>
